import api from './axiosConfig';

export const getAllReviews = async (page = 1, limit = 20) => {
  const response = await api.get('/reviews/all', { params: { page, limit } });
  return response.data;
};

export const getReviewStats = async () => {
  const response = await api.get('/reviews/stats');
  return response.data;
};

export const toggleVisibility = async (id) => {
  const response = await api.patch(`/reviews/${id}/toggle-visibility`);
  return response.data;
};

export const toggleFeatured = async (id) => {
  const response = await api.patch(`/reviews/${id}/toggle-featured`);
  return response.data;
};

export const updateReview = async (id, data) => {
  const response = await api.put(`/reviews/${id}`, data);
  return response.data;
};

export const deleteReview = async (id) => {
  const response = await api.delete(`/reviews/${id}`);
  return response.data;
};
